// src/pages/yenimahalle/MeclisUyeleri.tsx
import React, { ReactElement, useEffect, useState } from "react";
import Layout from "components/yenimahalle/Layout";
import BasicHeader from "components/yenimahalle/BasicHeader";
import ContactsGrid from "components/yenimahalle/ContactsGrid";
import PortalPeopleApi from "api/PortalPeopleApi";
import { MeclisUyeleriList } from "models/Response/PortalPeople";
import tw from "twin.macro";
import styled from "styled-components";
import { dateFormatter } from "utils/dateFormatter";

// reuse the same Heading style
const Heading = tw.span`
  inline-block my-4 pl-3 py-1 
  text-xl font-bold 
  border-l-4 border-primary-500
`;

// wrap each block in the real Tailwind container
const PartySection = styled.div`
  ${tw`container mx-auto`}
`;

export interface Card {
  imageSrc: string;
  title: string;
  description: ReactElement;
  titleText: string;
}

const organizationLabels: Record<string, string> = {
  CHP: "Cumhuriyet Halk Partisi Meclis Üyeleri",
  AKParti: "Adalet ve Kalkınma Partisi Meclis Üyeleri",
  MHP: "Milliyetçi Hareket Partisi Meclis Üyeleri",
};

const partyOrder = ["CHP", "AKParti", "MHP"];

const MeclisUyeleri: React.FC = () => {
  const [cards, setCards] = useState<Card[]>([]);

  useEffect(() => {
    PortalPeopleApi.getMeclisUyeleri().then((resp) => {
      if (resp?.meclisUyeleriList) {
        setCards(
          resp.meclisUyeleriList.map((m: MeclisUyeleriList) => ({
            imageSrc: m.imageUrl,
            title: m.nameSurname,
            description: (
              <>
                <strong>Doğum Yeri: </strong>{m.birthPlace}<br />
                <strong>Doğum Tarihi: </strong>{dateFormatter(m.birthDay, false)}<br />
                <strong>Meslek: </strong>{m.job}
              </>
            ),
            titleText: m.politicalOrganization,
          }))
        );
      }
    });
  }, []);

  const grouped = cards.reduce<Record<string, Card[]>>((acc, c) => {
    (acc[c.titleText] ||= []).push(c);
    return acc;
  }, {});

  return (
    <Layout>
      <BasicHeader headingLine1="" headingLine2="Meclis Üyeleri" />

      {partyOrder.map((partyKey) =>
        grouped[partyKey] ? (
          <PartySection key={partyKey}>
            <Heading>{organizationLabels[partyKey]}</Heading>
            <ContactsGrid cards={grouped[partyKey]} showTitleText={false} />
          </PartySection>
        ) : null
      )}
    </Layout>
  );
};

export default MeclisUyeleri;
